// 文件媒体数据格式
export function mediaData(materialInfo) {
  let obj_temp_type = 3; //类型(0-无1-文字2-图片3-视频4-音乐5-数时6-模时7-天气8-正计时9-倒时10-窗口11-日历14-流媒体1001-信号源),目前只支持2、3
  switch (materialInfo.type) { // 素材类型对应到模板类型,素材类型为--->(1-视频2-图片3-网页4-电视频点5-直播6-音乐10-文本)
    case 1:
      obj_temp_type = 3;
      break;
    case 2:
      obj_temp_type = 2;
      break;
    default:
      break;
  }
  return {
    field_item: {
      ext_val: {
        pimg: "",
        scaleType: 0,
        volume: 0,
        name: "",
        size: "",
        wh: "",
        duration: 0,
        playTime: 0,
        playCount: 1
      },
      id: "",
      val: ""
    },
    style: {
      fs: "0",
      ha: "0",
      va: "0"
    },
    wicket: [],
    type: obj_temp_type,
    field: "field_" + new Date().getTime(),
    field_cn: "文件",
    x: 0,
    y: 0,
    w: 1024,
    h: 768
  }
}

// 信号源数据格式
export function signalSourceData() {
  return {
    field_item: {
      ext_val: {
        url: "",
        pimg: "",
        scaleType: 0,
        name: "",
        size: 0,
        wh: "",
        duration: 10,
        volume: 50,
        rotation: 0,
        isVolumeGradual: false
      },
      id: 0,
      val: ""
    },
    style: { "fs": "0", "ha": "0", "va": "0" },
    wicket: [],
    type: "1001",
    field: "signal_" + new Date().getTime(),
    field_cn: "信号源",
    x: 0,
    y: 0,
    w: 1024,
    h: 768
  }
}
